import { render, staticRenderFns } from "./deduct_score.vue?vue&type=template&id=77877cc4&scoped=true"
import script from "./deduct_score.vue?vue&type=script&lang=js"
export * from "./deduct_score.vue?vue&type=script&lang=js"
import style0 from "./deduct_score.vue?vue&type=style&index=0&id=77877cc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77877cc4",
  null
  
)

export default component.exports